import ParentingView from './parenting-view'

export default ParentingView
